import React from 'react'
import TimeZoneSelector from './TimezonSelector'
import { useField } from 'formik'

const TimezoneFormik = (props) => {
  const { onChange, name, ...rest } = props
  const [field, meta, helpers] = useField(name)
  const value = field.value
  const setValue = helpers.setValue

  const changeValue = (value) => {
    setValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <TimeZoneSelector
      {...rest}
      {...meta}
      timezone={value}
      onChange={changeValue}
    />
  )
}

export default React.memo(TimezoneFormik)
